/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
    /* 01.General */
    'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

    /* 02.User Login, Logout, Register */
    'user.login-title': 'Login',
    'user.register': 'Register',
    'user.forgot-password': 'Forgot Password',
    'user.email': 'E-mail',
    'user.newpassword': 'New Password',
    'user.currentpassword': 'Current Password',
    'user.newpasswordagain': 'New Password Again',
    'user.password': 'Password',
    'user.forgot-password-question': 'Forget password?',
    'user.fullname': 'Full Name',
    'user.firstname': 'First Name',
    'user.lastname': 'Last Name',
    'user.login-button': 'LOGIN',
    'user.register-button': 'REGISTER',
    'user.reset-password-button': 'RESET',
    'user.buy': 'BUY',
    'user.username': 'Username',

    /* 03.Menu */
    'menu.app': 'Home',


    'menu.default': 'Default',
    'menu.analytics': 'Analytics',
    'menu.ecommerce': 'Ecommerce',
    'menu.content': 'Content',
    'menu.pages': 'Pages',
    'menu.data-list': 'Data List',
    'menu.thumb-list': 'Thumb List',
    'menu.image-list': 'Image List',
    'menu.details': 'Details',
    'menu.search': 'Search',
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.forgot-password': 'Forgot Password',
    'menu.error': 'Error',
    'menu.applications': 'Applications',
    'menu.todo': 'To-do List',
    'menu.survey': 'Survey',
    'menu.chat': 'Chat',
    'menu.ui': 'UI',
    'menu.edit': 'Edit',
    'menu.alerts': 'Alerts',
    'menu.badges': 'Badges',
    'menu.buttons': 'Buttons',
    'menu.cards': 'Cards',
    'menu.carousel': 'Carousel',
    'menu.charts': 'Charts',
    'menu.collapse': 'Collapse',
    'menu.dropdowns': 'Dropdowns',
    'menu.editors': 'Editors',
    'menu.form-layouts': 'Form Layouts',
    'menu.form-components': 'Form Components',
    'menu.form-validations': 'Form Validations',
    'menu.icons': 'Icons',
    'menu.input-groups': 'Input Groups',
    'menu.jumbotron': 'Jumbotron',
    'menu.modal': 'Modal',
    'menu.navigation': 'Navigation',
    'menu.popover-tooltip': 'Popover & Tooltip',
    'menu.sortable': 'Sortable',
    'menu.tables': 'Tables',
    'menu.menu': 'Menu',
    'menu.subhidden': 'Subhidden',
    'menu.hidden': 'Hidden',
    'menu.visible': 'Visible',
    'menu.maps': 'Maps',
    'menu.landingpage': 'Landing Page',
    'menu.multipage-home': 'Multipage Home',
    'menu.singlepage-home': 'Singlepage Home',
    'menu.about': 'About',
    'menu.auth-login': 'Auth Login',
    'menu.auth-register': 'Auth Register',
    'menu.blog': 'Blog',
    'menu.blog-detail': 'Blog Detail',
    'menu.careers': 'Careers',
    'menu.confirmation': 'Confirmation',
    'menu.contact': 'Contact',
    'menu.docs': 'Docs',
    'menu.features': 'Features',
    'menu.prices': 'Prices',
    'menu.videos': 'Videos',
    'menu.mailing': 'Mailing',
    'menu.invoice': 'Invoice',
    'menu.blank-page': 'Coming soon...',
    'menu.types': 'Menu Types',
    'menu.levels': 'Menu Levels',
    'menu.third-level-1': 'Third Level 1',
    'menu.third-level-2': 'Third Level 2',
    'menu.third-level-3': 'Third Level 3',

    /* 04.Dashboards */
    'dashboards.pending-orders': 'Pending Orders',
    'dashboards.completed-orders': 'Completed Orders',
    'dashboards.refund-requests': 'Refund Requests',
    'dashboards.new-comments': 'New Comments',
    'dashboards.sales': 'Sales',
    'dashboards.orders': 'Orders',
    'dashboards.refunds': 'Refunds',
    'dashboards.recent-orders': 'Recent Orders',
    'dashboards.product-categories': 'Product Categories',
    'dashboards.cakes': 'Cakes',
    'dashboards.tickets': 'Tickets',
    'dashboards.calendar': 'Calendar',
    'dashboards.best-sellers': 'Best Sellers',
    'dashboards.per-session': 'Per Session',
    'dashboards.profile-status': 'Profile Status',
    'dashboards.payment-status': 'Payment Status',
    'dashboards.work-progress': 'Work Progress',
    'dashboards.tasks-completed': 'Tasks Completed',
    'dashboards.payments-done': 'Payments Done',
    'dashboards.order-stock': 'Order - Stock',
    'dashboards.categories': 'Categories',
    'dashboards.quick-post': 'Quick Post',
    'dashboards.title': 'Title',
    'dashboards.content': 'Content',
    'dashboards.category': 'Category',
    'dashboards.save-and-publish': 'Save and Publish',
    'dashboards.top-viewed-posts': 'Top Viewed Posts',
    'dashboards.posts': 'Posts',
    'dashboards.pending-for-publish': 'Pending for publish',
    'dashboards.users': 'Users',
    'dashboards.on-approval-process': 'On approval process',
    'dashboards.alerts': 'Alerts',
    'dashboards.waiting-for-notice': 'Waiting for notice',
    'dashboards.files': 'Files',
    'dashboards.pending-for-print': 'Pending for print',
    'dashboards.logs': 'Logs',
    'dashboards.gogo': 'GOGO',
    'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
    'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
    'dashboards.advanced-search': 'Advanced Search',
    'dashboards.toppings': 'Toppings',
    'dashboards.type': 'Type',
    'dashboards.keyword': 'Keyword',
    'dashboards.search': 'Search',
    'dashboards.top-rated-items': 'Top Rated Items',
    'dashboards.topic': 'Topic',
    /* 05.Pages */
    'pages.title.dashboards.analytics': 'Analytics',
    'pages.title.ari': 'Availability and Rates',
    'pages.title.conversations': 'Conversations',
    'pages.title.bookings': 'Reservations and Bookings',
    'pages.title.tickets': 'Leads and Tickets',
    'pages.title.propinfo': 'Responses',
    'pages.title.discounts': 'Discounts and Promotions',
    'pages.title.finance': 'Finance',
    'pages.title.integration': 'Integration',
    'pages.title.admin': 'Admin',
    'pages.add-new': 'ADD NEW',
    'pages.add-new-modal-title': 'Add New Item',
    'pages.display-options': 'Display Options',
    'pages.orderby': 'Order By : ',
    'pages.product-name': 'Product Name',
    'pages.category': 'Category',
    'pages.description': 'Description',
    'pages.status': 'Status',
    'pages.cancel': 'Cancel',
    'pages.submit': 'Submit',
    'pages.delete': 'Delete',
    'pages.another-action': 'Another action',
    'pages.actions': 'ACTIONS',
    'pages.header': 'Header',
    'pages.details': 'DETAILS',
    'pages.orders': 'ORDERS',
    'pages.rating': 'Rating',
    'pages.price': 'Price',
    'pages.ingredients': 'Ingredients',
    'pages.is-vegan': 'Is Vegan',
    'pages.order-status': 'Order Status',
    'pages.bake-progress': 'Bake Progress',
    'pages.popularity': 'Popularity',
    'pages.comments': 'Comments',
    'pages.error-title': 'Ooops... looks like an error occurred!',
    'pages.error-code': 'Error code',
    'pages.go-back-home': 'GO BACK HOME',
    'pages.mailing-info':
        'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
    'pages.invoice-info':
        'Invoice template has an inline styled version for usage outside of the project as well as React version.',
    'pages.react-version': 'React Version',
    'pages.inline-version': 'Inline Styled Html Version',

    /* 06.Applications */

    /* 06.01.Chat */
    'chat.messages': 'Viestit',
    'chat.contacts': 'Yhteystiedot',
    'chat.saysomething': 'Sano jotain..',

    /* 06.02.Survey */
    'survey.delete': 'Poistaa',
    'survey.edit': 'Muokata',
    'survey.add-new': 'LISÄÄ UUSI',
    'survey.add-new-title': 'Lisää uusi kysely',
    'survey.title': 'Otsikko',
    'survey.category': 'Kategoria',
    'survey.label': 'Label',
    'survey.status': 'Tila',
    'survey.cancel': 'Peruuttaa',
    'survey.submit': 'Lähetä',
    'survey.another-action': 'Another action',
    'survey.display-options': 'Display Options',
    'survey.orderby': 'Order By : ',
    'survey.all-surveys': 'All Surveys',
    'survey.completed-surveys': 'Completed Surveys',
    'survey.categories': 'Categories',
    'survey.active-surveys': 'Active Surveys',
    'survey.labels': 'Labels',

    /* 06.03.Todo */
    'todo.add-new': 'ADD NEW',
    'todo.add-new-title': 'Add New Todo',
    'todo.title': 'Title',
    'todo.detail': 'Detail',
    'todo.category': 'Category',
    'todo.label': 'Label',
    'todo.status': 'Status',
    'todo.cancel': 'Cancel',
    'todo.submit': 'Submit',
    'todo.action': 'Action',
    'todo.another-action': 'Another action',
    'todo.display-options': 'Display Options',
    'todo.orderby': 'Order By : ',
    'todo.all-tasks': 'All Tasks',
    'todo.pending-tasks': 'Pending Tasks',
    'todo.completed-tasks': 'Completed Tasks',
    'todo.categories': 'Categories',
    'todo.labels': 'Labels',

    /* 07.UI */

    /* 07.01.Alerts */
    'alert.rounded': 'Rounded Alert',
    'alert.react-notifications': 'React Notifications',
    'alert.outline': 'Outline',
    'alert.primary': 'Primary',
    'alert.secondary': 'Secondary',
    'alert.info': 'Info',
    'alert.success': 'Success',
    'alert.warning': 'Warning',
    'alert.error': 'Error',
    'alert.filled': 'Filled',
    'alert.primary-text': 'This is a primary alert—check it out!',
    'alert.secondary-text': 'This is a secondary alert—check it out!',
    'alert.success-text': 'This is a success alert—check it out!',
    'alert.danger-text': 'This is a danger alert—check it out!',
    'alert.warning-text': 'This is a warning alert—check it out!',
    'alert.info-text': 'This is a info alert—check it out!',
    'alert.light-text': 'This is a light alert—check it out!',
    'alert.dark-text': 'This is a dark alert—check it out!',
    'alert.default': 'Default Alert',
    'alert.dismissing': 'Dismissing Alert',
    'alert.dismissing-text':
        'Holy guacamole! You should check in on some of those fields below.',
    'alert.dismissing-without-animate-text':
        'I am an alert and I can be dismissed without animating!',

    /* 07.02.Badges */
    'badge.sizes': 'Sizes',
    'badge.colors': 'Colors',
    'badge.outline': 'Outline',
    'badge.links': 'Links',
    'badge.counter-badges': 'Counter Badges',
    'badge.bootstrap-default': 'Bootstrap Default',
    'badge.primary': 'Primary',
    'badge.secondary': 'Secondary',
    'badge.success': 'Success',
    'badge.danger': 'Danger',
    'badge.warning': 'Warning',
    'badge.info': 'Info',
    'badge.light': 'Light',
    'badge.dark': 'Dark',

    /* 07.03.Buttons */
    'button.default': 'Bootstrap Default',
    'button.colors': 'Colors',
    'button.rounded': 'Rounded',
    'button.outline': 'Outline',
    'button.states': 'States',
    'button.sizes': 'Sizes',
    'button.button-groups': 'Button Groups',
    'button.large-button': 'Large Button',
    'button.small-button': 'Small Button',
    'button.extra-small-button': 'Extra Small Button',
    'button.block-button': 'Block Button',
    'button.active': 'Active',
    'button.disabled': 'Disabled',
    'button.basic': 'Basic',
    'button.toolbar': 'Toolbar',
    'button.nesting': 'Nesting',
    'button.vertical-variation': 'Vertical Variation',
    'button.checkbox-radio-button': 'Checkbox and Radio Button',
    'button.checkbox': 'Checkbox',
    'button.radio': 'Radio',
    'button.radio-button': 'Radio Button',
    'button.primary': 'Primary',
    'button.secondary': 'Secondary',
    'button.success': 'Success',
    'button.danger': 'Danger',
    'button.warning': 'Warning',
    'button.info': 'Info',
    'button.light': 'Light',
    'button.dark': 'Dark',
    'button.states-text':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.click-here': 'Click Here',
    'button.states-text-alternate':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.primary-link': 'Primary Link',
    'button.link': 'Link',
    'button.primary-button': 'Primary Button',
    'button.button': 'Button',
    'button.left': 'Left',
    'button.middle': 'Middle',
    'button.right': 'Right',
    'button.dropdown': 'Dropdown',
    'button.dropdown-link': 'Dropdown Link',

    /* 07.04.Cards */
    'cards.icon-card': 'Icon Card',
    'cards.image-card': 'Image Card',
    'cards.image-overlay-card': 'Image Overlay Card',
    'cards.image-card-list': 'Image Card List',
    'cards.tab-card': 'Tab Card',
    'cards.user-card': 'User Card',

    /* 07.05.Carousel */
    'carousel.basic': 'Carousel Basic',
    'carousel.single': 'Carousel Single',
    'carousel.without-controls': 'Carousel Without Controls',

    /* 07.06.Charts */
    'charts.line': 'Line Chart',
    'charts.polar': 'Polar Chart',
    'charts.area': 'Area Chart',
    'charts.scatter': 'Scatter Chart',
    'charts.bar': 'Bar Chart',
    'charts.radar': 'Radar Chart',
    'charts.pie': 'Pie Chart',
    'charts.doughnut': 'Doughnut Chart',
    'charts.shadow': 'Shadow',
    'charts.no-shadow': 'No Shadow',

    /* 07.07.Collapse */
    'collapse.basic': 'Basic',
    'collapse.toggle': 'Toggle',
    'collapse.accordion': 'Accordion',
    'collapse.controlled': 'Controlled',
    'collapse.uncontrolled': 'Uncontrolled',

    /* 07.08.Dropdowns */
    'dropdowns.basic': 'Basic',
    'dropdowns.controlled': 'Controlled',
    'dropdowns.uncontrolled': 'Uncontrolled',
    'dropdowns.dropdown': 'Dropdown',
    'dropdowns.header': 'Header',
    'dropdowns.action': 'Action',
    'dropdowns.another-action': 'Another Action',
    'dropdowns.right': 'Right',
    'dropdowns.left': 'Left',
    'dropdowns.drop-directions': 'Drop Directions',
    'dropdowns.dropright': 'Dropright',
    'dropdowns.dropleft': 'Dropleft',
    'dropdowns.small-button': 'Small Button',
    'dropdowns.large-button': 'Large Button',
    'dropdowns.sizing': 'Sizing',
    'dropdowns.split-button': 'Split Button Dropdowns',
    'dropdowns.dropup': 'Dropup',

    /* 07.09.Editors */
    'editors.draftjs': 'Draft.js',
    'editors.quill-standart': 'Quill Standard',
    'editors.quill-bubble': 'Quill Bubble',

    /* 07.10.Forms */
    'forms.basic': 'Basic',
    'forms.email': 'E-mail',
    'forms.email-muted': "We'll never share your email with anyone else.",
    'forms.password': 'Password',
    'forms.submit': 'Submit',
    'forms.horizontal': 'Horizontal',
    'forms.radios': 'Radios',
    'forms.first-radio': 'First radio',
    'forms.second-radio': 'Second radio',
    'forms.third-radio-disabled': 'Third disabled radio',
    'forms.checkbox': 'Checkbox',
    'forms.signin': 'Sign in',
    'forms.top-labels-over-line': 'Top Labels Over Line',
    'forms.tags': 'Tags',
    'forms.date': 'Date',
    'forms.state': 'State',
    'forms.top-labels-in-input': 'Top Labels In Input',
    'forms.email-u': 'E-MAIL',
    'forms.password-u': 'PASSWORD',
    'forms.tags-u': 'TAGS',
    'forms.date-u': 'DATE',
    'forms.state-u': 'STATE',
    'forms.grid': 'Form Grid',
    'forms.address': 'Address',
    'forms.address2': 'Address 2',
    'forms.city': 'City',
    'forms.city-message': 'Please select a city!',
    'forms.state-message': 'Please select a state!',
    'forms.zip': 'Zip',
    'forms.signup': 'Signup',
    'forms.inline': 'Inline',
    'forms.validation-availity': 'Availity Reactstrap Validation',
    'forms.validation-formik': 'Formik Validation',
    'forms.default': 'Default',
    'forms.firstname': 'First name',
    'forms.firstname-message': 'Please enter your first name!',
    'forms.lastname': 'Last name',
    'forms.lastname-message': 'Please enter your last name!',

    /* 07.11.Form Components */
    'form-components.custom-inputs': 'Custom Inputs',
    'form-components.checkboxes': 'Checkboxes',
    'form-components.radios': 'Radios',
    'form-components.inline': 'Inline',
    'form-components.react-select': 'React Select',
    'form-components.state-single': 'State Single',
    'form-components.state-multiple': 'State Multiple',
    'form-components.react-autosuggest': 'React Autosuggest',
    'form-components.date-picker': 'Date Picker',
    'form-components.date': 'Date',
    'form-components.date-range': 'Date Range',
    'form-components.date-with-time': 'Date with Time',
    'form-components.embedded': 'Embedded',
    'form-components.dropzone': 'Dropzone',
    'form-components.drop-files-here': 'Drop Files Here',
    'form-components.tags': 'Tags',
    'form-components.switch': 'Switch',
    'form-components.primary': 'Primary',
    'form-components.secondary': 'Secondary',
    'form-components.primary-inverse': 'Primary Inverse',
    'form-components.secondary-inverse': 'Secondary Inverse',
    'form-components.slider': 'Slider',
    'form-components.double-slider': 'Double Slider',
    'form-components.single-slider': 'Single Slider',
    'form-components.rating': 'Rating',
    'form-components.interactive': 'Interactive',
    'form-components.readonly': 'Readonly',
    'form-components.type-a-cake': 'Type a Cake',
    'form-components.start': 'Start',
    'form-components.end': 'End',
    'form-components.tables': 'Tables',
    /* 07.12.Icons */
    'icons.simplelineicons': 'Simple Line Icons',
    'icons.iconsmind': 'Iconsmind Icons',

    /* 07.13.Input Groups */
    'input-groups.basic': 'Basic',
    'input-groups.sizing': 'Sizing',
    'input-groups.small': 'Small',
    'input-groups.default': 'Default',
    'input-groups.large': 'Large',
    'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
    'input-groups.multiple-inputs': 'Multiple Inputs',
    'input-groups.first-and-last-name': 'First and last name',
    'input-groups.multiple-addons': 'Multiple Addons',
    'input-groups.button-addons': 'Button Addons',
    'input-groups.button': 'Button',
    'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
    'input-groups.dropdown': 'Dropdown',
    'input-groups.header': 'Header',
    'input-groups.action': 'Action',
    'input-groups.another-action': 'Another Action',
    'input-groups.custom-select': 'Custom Select',
    'input-groups.options': 'Options',
    'input-groups.choose': 'Choose...',
    'input-groups.custom-file-input': 'Custom File Input',

    /* 07.14.Jumbotron */
    'jumbotron.hello-world': 'Hello, world!',
    'jumbotron.lead':
        'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
    'jumbotron.lead-detail':
        'It uses utility classes for typography and spacing to space content out within the larger container.',
    'jumbotron.learn-more': 'Learn more',

    /* 07.15.Modal */
    'modal.basic': 'Basic',
    'modal.modal-title': 'Modal title',
    'modal.launch-demo-modal': 'Launch Demo Modal',
    'modal.scrolling-long-content': 'Scrolling Long Content',
    'modal.backdrop': 'Backdrop',
    'modal.backdrop-value': 'Backdrop value',
    'modal.right-modal': 'Right Modal',
    'modal.launch-right-modal': 'Launch Right Modal',
    'modal.nested-modal': 'Nested Modal',
    'modal.size': 'Size',
    'modal.launch-large-modal': 'Launch Large Modal',
    'modal.launch-small-modal': 'Launch Small Modal',

    /* 07.16.Navigation */
    'nav.basic': 'Nav Basic',
    'nav.active': 'Active',
    'nav.disabled': 'Disabled',
    'nav.disabled-link': 'Disabled Link',
    'nav.link': 'Link',
    'nav.longer-link': 'Longer nav link',
    'nav.another-link': 'Another Link',
    'nav.right': 'Right',
    'nav.dropdown': 'Dropdown',
    'nav.header': 'Header',
    'nav.action': 'Action',
    'nav.another-action': 'Another Action',
    'nav.horizontal-alignment': 'Nav Horizontal Alignment',
    'nav.vertical-alignment': 'Nav Vertical Alignment',
    'nav.pills': 'Nav Pills',
    'nav.fill-justify': 'Nav Fill and Justify',
    'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
    'nav.pagination-basic': 'Pagination Basic',
    'nav.pagination-sizing': 'Pagination Sizing',
    'nav.large': 'Large',
    'nav.small': 'Small',
    'nav.center': 'Center',
    'nav.pagination-alignment': 'Pagination Alignment',
    'nav.breadcrumb-basic': 'Breadcrumb Basic',

    /* 07.17.Popover & Tooltip */
    'popover-tooltip.popover': 'Popover',
    'popover-tooltip.tooltip': 'Työkaluvinkki',

    /* 07.18.Sortable */
    'sortable.columns': 'Sarakkeiden lajittelu',
    'sortable.basic': 'Perus',
    'sortable.handles': 'Kahvat',

    /* 07.19.Maps */
    'maps.google': 'Google',
    'maps.yandex': 'Yandex',

    /* 07.20.Tables */
    'table.bootstrap-tables': 'Bootstrap-taulukot',
    'table.bootstrap-basic': 'Perustaulukko',
    'table.bootstrap-striped': 'Raidalliset rivit',
    'table.bootstrap-bordered': 'Reunattu taulukko',
    'table.bootstrap-borderless': 'Reunaton pöytä',
    'table.bootstrap-hoverable': 'Liukuvat rivit',
    'table.bootstrap-responsive': 'Responsiivinen taulukko',
    'table.react-tables': 'Reaktiotaulukot',
    'table.react-pagination': 'Sivunumerointi',
    'table.react-scrollable': 'vieritettävä',
    'table.react-advanced': 'Suodata, pituus ja hyppy',

    /* Property Info */
    'property-info.about-property': 'Tietoja omaisuudesta',
    'property-info.about-properties': 'Tietoja ominaisuuksista',
    'property-info.facilities-services': 'Tilat ja palvelut',
    'property-info.property-facilities': 'Kiinteistön tilat',
    'property-info.room-amenities': 'Huoneen mukavuudet',
    'property-info.property-contact': 'Kiinteistön yhteystiedot',
    'property-info.property-activities': 'Kiinteistöalan toiminta',
    'property-info.property-location': 'Kiinteistön sijainti',
    'property-info.about-rooms': 'Tietoja Huoneista',
    'property-info.about-sites': 'Tietoja sivustoista',
    'property-info.special-emergencies': 'Hätätilanteet',
    'property-info.gallery': 'Galleria',
    'property-info.policies': 'Käytännöt',
    'property-info.nearby': 'Lähistöllä',
    'property-info.transport': 'Kuljetus',
    'property-info.location': 'Sijainti',
    'property-info.about-rhproperty': 'Tietoja vanhainkodista',
    'property-info.related-topics': 'Liittyvät aiheet',
    'property-info.assistant-options': 'Assistant-valikko',
    'property-info.restaurant-assistant-information': 'Ravintolan tiedot',
    'property-info.restaurant-assistant-options': 'Tervetuloviesti',
    'property-info.channel-messages': 'Kanavan viestit',
    'property-info.icon.gallery': 'Ikoni galleria',
    'property-info.copilot': 'Lentoperämies',
    'property-info.sprint': 'Sprintti',
    'property-info.home-information': 'Kotitiedot',
    'property-info.loction': 'Sijainnit',
    'property-info.rooms-and-images': 'Huoneet ja kuvat',
    'property-info.trainig-data': 'Koulutustiedot',
    'property-info.flows': 'Virtaukset',
    'property-info.add-your-own': 'Lisää omasi',
    'property-info-utility-miscellaneous': 'Sekalaista',
    'property-info-utility-payment': 'Maksut',
    'property-info-utility-broadband': 'Laajakaista',
    'property-info-utility-emergency': 'Hätä',
    'property-info-utility-mobile': 'mobiili',
    'property-info-utility-moving': 'Liikkuva',

    /** Rate & Promo */
    'rate-promo.rate-plans': 'Hintasuunnitelmat',
    'rate-promo.rate-plan-addons': "Lisäosat",
    'rate-promo.rate-plan-promos': 'Kampanjat',

    'title.property-information': 'Kiinteistön tiedot',

    'property.message': 'Viesti',
    'property.example': 'Esimerkki',
    'property.link': 'Linkit',
    'property.image-carousel': 'Kuvakaruselli',
    'property.Title': 'Otsikko',
    'property.SubTitle': 'Alaotsikko',

    'property.add-invoke-api': 'Kutsu Api',
    'property.add-message-button': 'Lisää viestejä',
    'property.add-img-button': 'Lisää kuvia',
    'property.add-link-button': 'Lisää linkki',
    'property.add-herocard-button': 'Lisää sankarikortti',
    'property.add-api-button': 'Lisää painikkeita',

    'menu.about-property': 'Tietoja omaisuudesta',
    'menu.property-facilities': 'Kiinteistön tilat',
    'menu.room-amenities': 'Huoneen mukavuudet',
    'menu.property-contact': 'Kiinteistön yhteystiedot',
    'menu.about-rooms': 'Tietoja Huoneista',
    'menu.special-emergencies': 'Hätätilanteet',
    'menu.show-filter': 'suodattimet',
    'menu.new': 'Uusi',

    'dashboards.common-asked': 'Usein kysytyt kysymykset',
    'dashboards.website-visitor-asking': 'Asiat, joista sivuston vierailijat kysyvät',
    'dashboards.visit-country': 'Sivustovierailu maittain',
    'dashboards.visit-traffic': 'Sivuston liikenteen maa',
    'dashboards.rooms-product': 'Huoneet ja tuotteet',
    'dashboards.popular-room-product': 'Suosittuja huoneita ja tuotteita',

    'dashboards.messenger-stats': 'Suositut valikkokohdat',
    'dashboards.messenger-stats-topic-view': 'Tilastot valikon kohteiden näkymistä',
    'dashboards.messenger-stats-visits': 'Valikkokohteiden näkymät',
    'dashboards.opening-menu-items': 'Niiden verkkosivuston vierailijoiden määrä, jotka avaavat valikon kohteita',

    'dashboards.number-totalavatarclick': 'Avatar-klikkaukset yhteensä',

    'dashboards.clicks': 'Napsautukset',
    'dashboards.leads': 'Johtoja',
    'dashboards.hours': 'Tuntia',
    'dashboards.minutes': 'Pöytäkirja',

    'dashboards.ai-chatbot': 'AI Chatbot',
    'dashboards.compendium': 'Compendium',
    'dashboards.compendium-digital-usage': 'Digitaalisen kokoelman käyttö',
    'dashboards.compendium-unique-visits': 'Ainutlaatuisia vierailuja',
    'dashboards.compendium-opening-menu-items': 'Katsottujen valikkokohtien määrä',
    'dashboards.compendium-total-digital-clicks': 'Digital Compendiumin napsautukset yhteensä',

    'property.delete': 'Poistaa',
    'menu.userroles': 'Käyttäjät ja roolit',
    'menu.ratebookings': 'Hinnat ja varaukset',
    'dashboards.engagement-time': 'Digital Assistantin sitoutumisaika',
    'dashboards.conversations-minutes': 'Minuutit ja yön yli (klo 19–7) keskusteluminuutit yhteensä',
    'dashboards.visitor-questions': 'Vierailijan kysymykset',
    'dashboards.recent-queries': 'Viimeaikaiset kyselyt',
    'dashboards.visitor-saying': 'Mitä vierailijasi sanovat Digital Assistantille',
    'dashboards.contacts-prechatform-leavemessage': 'Tallennetut yhteystiedot Pre Chat -lomakkeesta ja jätä viesti',
    'menu.dashboards': 'Näkemyksiä',
    'menu.ari': 'Saatavuus ja hinnat',
    'menu.conversations': 'Keskustelut',
    'menu.conversations.unified-inbox': 'Yhdistetty postilaatikko',
    'menu.conversations.active': 'Aktiiviset keskustelut',
    'menu.conversations.archives': 'Arkistot',
    'menu.conversations.missed-responses': 'Jääneet vastaukset',
    'menu.conversations.ticket': 'Liput',
    'menu.conversations.reply-templates': 'Vastausmallit',
    'menu.bookings': 'Varaukset ja varaukset',
    'menu.tickets': 'Johdot ja liput',
    'menu.propinfo': 'Knowledge Hub',
    'menu.rate-promos': 'Hinnat ja tarjoukset',
    'menu.finance': 'Rahoittaa',
    'menu.integration': 'Kytkeä',
    'menu.admin': 'Järjestelmänvalvoja ja suojaus',
    'menu.favourites': 'Suosikit',
    'menu.recommender': 'Keskustelukulku',
    'menu.assistant-setup': 'Assistantin asetukset',
    'menu.admin-insights': 'Admin Insights',
    'menu.super-admin': 'Super Admin',
    'menu.groups': 'ryhmät',
    'menu.properties': 'Ominaisuudet',
    'menu.service-provider': 'Palveluntarjoajat',
    'menu.spaces': 'Spaces',

    'dashboards.space-booking': 'Tilavaraus',
    'dashboards.gift-voucher': 'Lahjakortit',
    'dashboards.chatbots': 'Chatbotit',
    'dashboards.form': 'From',
    'dashboards.to': 'Vastaanottaja',
    'dashboards.active-groups': 'Aktiiviset ryhmät',
    'dashboards.active-properties': 'Aktiiviset ominaisuudet',
    'dashboards.live-properties': 'Live-ominaisuudet',
    'dashboards.properties-going': 'Kiinteistöt julkaistaan ​​ajanjakson mukaan',
    'dashboards.start-date': 'Aloituspäivämäärä',
    'dashboards.end-date': 'Päättymispäivämäärä',

    'dashboards.website-visits': 'Vierailut verkkosivuilla',
    'dashboards.unique-visitors': 'Ainutlaatuiset Vierailijat',
    'dashboards.last-week': 'Viime viikko',
    'dashboards.this-week': 'Tämä viikko',
    'dashboards.this-month': 'Tässä kuussa',
    'dashboards.previous-month': 'Edellinen kuukausi',
    'dashboards.yeartodate': 'Päivälleen vuosi',
    'dashboards.lastyear': 'Viime vuonna',
    'dashboards.last-7-days': 'Viimeiset 7 päivää',
    'dashboards.last-30-days': 'Viimeiset 30 päivää',
    'dashboards.last-60-days': 'Viimeiset 60 päivää',
    'dashboards.last-90-days': 'Viimeiset 90 päivää',
    'dashboards.conversion-rates': 'Muuntokurssit',
    'dashboards.digital-assistant-engagement': 'Digital Assistant Engagement',
    'dashboards.total-overnight-conversations': 'Yhteensä ja yön yli (klo 19–7) keskustelut',
    'dashboards.percentage-accuracy': 'Tarkkuuden ymmärtäminen',
    'dashboards.percentage-conversion': 'Verkkosivuston liikenne chat-muunnos',
    'dashboards.percentage-avatarclick': 'Verkkosivuston liikenne avatar-napsautuksiin',
    'dashboards.percentage-negativefeedback': 'Negatiivinen palaute avatar-napsautusten prosentteina',
    'dashboards.percentage-amenties': 'Palvelukyselyt',
    'dashboards.percentage-booking': 'Varauskyselyt',
    'dashboards.percentage-webchats': 'Verkkosivuston chatit',
    'dashboards.percentage-facebookchat': 'Facebook-chatit',
    // 'dashboards.number-webchattime': 'Total Web Chat Time',
    'dashboards.number-webchattime': 'Koko keskusteluaika',
    'dashboards.number-totalconversation': 'Keskustelut yhteensä',
    'dashboards.number-websiteconversation': 'Verkkosivuston keskustelut',
    'dashboards.number-facebookconversation': 'Facebook-keskustelut',
    'dashboards.number-estimatedtimesaving': 'Arvioitu ajansäästö',
    'dashboards.number-googlemapsconversation': 'Google Maps -keskustelut',
    'dashboards.number-whatsappconversation': 'WhatsApp-keskustelut',
    'dashboards.number-instagramconversation': 'Instagram-keskustelut',
    'dashboards.number-agentconversation': 'Agentin keskustelut',
    'dashboards.number-amenityqueries': 'Palvelukyselyt',
    'dashboards.number-bookingenquiries': 'Varauskyselyt',
    'dashboards.number-groupbookingenquiries': 'Ryhmävarauskyselyt',
    'dashboards.number-eventenquiries': 'Tiedustelut tapahtumista',
    'dashboards.number-longstayenquiries': 'Pitkän oleskelun tiedustelut',
    'dashboards.number-totaltickets': 'Liput',
    'dashboards.number-returncustomer': 'Paluuasiakas',
    'dashboards.number-redirects': 'Verkkosivustojen uudelleenohjaukset',
    'dashboards.number-bookingengineleads': 'Moottorin johtojen varaus',
    'dashboards.number-roomnightsreferred': "Viitetyt huoneyöt",
    'dashboards.number-revenuereferred': "Viitattu tulo",
    'menu.bookingsmenu': 'Varaukset',
    'menu.guests': 'Vieraiden tiedot',
    'menu.whatsnew': "Mikä on uutta",

    'menu.formbuilder': 'Lomakkeiden rakentaja',
    'forms.forms-title': 'Lomakkeet',

    'menu.virtualfrontdesk': 'Virtuaalinen vastaanotto',
    'menu.guestservice': 'Vieraspalvelut',
    'virtual-front.common-questions': "Yleisiä kysymyksiä",
    'virtual-front.add-on-upsells': "Lisäosat ja lisämyynti",
    'virtual-front.service-order': "Palvelutilaukset",
    // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
    'virtual-front.guest-service-add-on-upsells': "Digitaalinen vieraskirja",
    'virtual-front.outbound': "Lähtevä",
    'virtual-messenger': "sanansaattaja",

    'missed-response.missed-response-title': "Unohtunut vastauksen otsikko",
};
